import { useEffect, useMemo, useState } from 'react';

import PageTitle from '@/components/common/PageTitle/PageTitle';
import Page from '@/components/Page/Page';
import { importingToolTab, settingsTabs, bulkUpdateTab } from './tabs';
import TagTabs from '@/components/common/TagTabs/TagTabs';
import { useAddQueryToUrl } from '@/components/common/TagTabs/useAddQueryToUrl';
import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import { UserRole } from '@/config/roles.config';

const DEFAULT_TAB = 'BILLING-RENEWALS';
const importingAndBulkUpdateValidRoles = [UserRole.FULL_ACCESS];

export default function SystemAdmin() {
  const { getValue } = useAddQueryToUrl();
  const activeTab = getValue('tab') ?? DEFAULT_TAB;
  const { getUserRole } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();

  const tabs = useMemo(() => {
    return userRole && importingAndBulkUpdateValidRoles.includes(userRole)
      ? [...settingsTabs, importingToolTab, bulkUpdateTab]
      : settingsTabs;
  }, [userRole]);

  useEffect(() => {
    const getRole = async () => {
      const roleName = await getUserRole();
      setUserRole(roleName);
    };

    getRole();
  }, [getUserRole]);

  return (
    <Page
      padding={true}
      pageTitle="System Admin"
    >
      <PageTitle title="System Admin" />
      <div className="mt-10">
        <TagTabs
          tabs={tabs}
          activeTabKey={activeTab}
          cacheMode="no-cache" />
      </div>
    </Page>
  );
}
